
import { SalesData } from '../types';

// Sample sales data for testing
export const mockSalesData: SalesData[] = [
  {
    id: 'sale1',
    invoiceId: 'INV-20250422-001',
    requestOrderNumber: 'RO-20250422-001',
    fulfillmentOrderNumber: 'RSO-20250422-001',
    superAdminId: 'sa-001',
    superAdminName: 'John Admin',
    instanceId: 'inst-001',
    instanceName: 'example.com',
    planName: 'Business Pro',
    billingCycle: 'yearly',
    amount: 599.99,
    date: new Date('2025-04-22'),
    status: 'paid',
    isRecurring: true
  },
  {
    id: 'sale2',
    invoiceId: 'INV-20250421-005',
    requestOrderNumber: 'RO-20250421-005',
    fulfillmentOrderNumber: 'RSO-20250421-005',
    superAdminId: 'sa-002',
    superAdminName: 'Alice Smith',
    instanceId: 'inst-002',
    instanceName: 'sample.net',
    planName: 'Basic',
    billingCycle: 'monthly',
    amount: 99.99,
    date: new Date('2025-04-21'),
    status: 'pending',
    isRecurring: true
  },
  {
    id: 'sale3',
    invoiceId: 'INV-20250420-012',
    requestOrderNumber: 'RO-20250420-012',
    fulfillmentOrderNumber: 'RSO-20250420-012',
    superAdminId: 'sa-001',
    superAdminName: 'John Admin',
    instanceId: 'inst-003',
    instanceName: 'test-app.org',
    planName: 'Enterprise',
    billingCycle: 'yearly',
    amount: 1299.99,
    date: new Date('2025-04-20'),
    status: 'paid',
    isRecurring: true
  },
  {
    id: 'sale4',
    invoiceId: 'INV-20250419-003',
    requestOrderNumber: 'RO-20250419-003',
    fulfillmentOrderNumber: 'RSO-20250419-003',
    superAdminId: 'sa-003',
    superAdminName: 'Bob Johnson',
    instanceId: 'inst-004',
    instanceName: 'innovate-now.com',
    planName: 'Business Pro',
    billingCycle: 'monthly',
    amount: 699.99,
    date: new Date('2025-04-19'),
    status: 'failed',
    isRecurring: true
  },
  {
    id: 'sale5',
    invoiceId: 'INV-20250418-008',
    requestOrderNumber: 'RO-20250418-008',
    fulfillmentOrderNumber: 'RSO-20250418-008',
    superAdminId: 'sa-002',
    superAdminName: 'Alice Smith',
    instanceId: 'inst-005',
    instanceName: 'solutions-4u.net',
    planName: 'Basic',
    billingCycle: 'yearly',
    amount: 199.99,
    date: new Date('2025-04-18'),
    status: 'paid',
    isRecurring: true
  },
  {
    id: 'sale6',
    invoiceId: 'INV-20250417-015',
    requestOrderNumber: 'RO-20250417-015',
    fulfillmentOrderNumber: 'RSO-20250417-015',
    superAdminId: 'sa-001',
    superAdminName: 'John Admin',
    instanceId: 'inst-006',
    instanceName: 'global-tech.org',
    planName: 'Enterprise',
    billingCycle: 'monthly',
    amount: 1499.99,
    date: new Date('2025-04-17'),
    status: 'pending',
    isRecurring: true
  },
  {
    id: 'sale7',
    invoiceId: 'INV-20250416-002',
    requestOrderNumber: 'RO-20250416-002',
    fulfillmentOrderNumber: 'RSO-20250416-002',
    superAdminId: 'sa-003',
    superAdminName: 'Bob Johnson',
    instanceId: 'inst-007',
    instanceName: 'apex-systems.com',
    planName: 'Business Pro',
    billingCycle: 'yearly',
    amount: 799.99,
    date: new Date('2025-04-16'),
    status: 'paid',
    isRecurring: true
  },
  {
    id: 'sale8',
    invoiceId: 'INV-20250415-009',
    requestOrderNumber: 'RO-20250415-009',
    fulfillmentOrderNumber: 'RSO-20250415-009',
    superAdminId: 'sa-002',
    superAdminName: 'Alice Smith',
    instanceId: 'inst-008',
    instanceName: 'pinnacle-group.net',
    planName: 'Basic',
    billingCycle: 'monthly',
    amount: 299.99,
    date: new Date('2025-04-15'),
    status: 'failed',
    isRecurring: true
  },
  {
    id: 'sale9',
    invoiceId: 'INV-20250414-016',
    requestOrderNumber: 'RO-20250414-016',
    fulfillmentOrderNumber: 'RSO-20250414-016',
    superAdminId: 'sa-001',
    superAdminName: 'John Admin',
    instanceId: 'inst-009',
    instanceName: 'vanguard-tech.org',
    planName: 'Enterprise',
    billingCycle: 'yearly',
    amount: 1599.99,
    date: new Date('2025-04-14'),
    status: 'paid',
    isRecurring: true
  },
  {
    id: 'sale10',
    invoiceId: 'INV-20250413-004',
    requestOrderNumber: 'RO-20250413-004',
    fulfillmentOrderNumber: 'RSO-20250413-004',
    superAdminId: 'sa-003',
    superAdminName: 'Bob Johnson',
    instanceId: 'inst-010',
    instanceName: 'elite-innovations.com',
    planName: 'Business Pro',
    billingCycle: 'monthly',
    amount: 899.99,
    date: new Date('2025-04-13'),
    status: 'pending',
    isRecurring: true
  }
];

// Helper function to calculate total sales
export const calculateTotalSales = (data: SalesData[]): number => {
  return data.reduce((total, sale) => total + sale.amount, 0);
};

// Helper function to filter sales by status
export const filterSalesByStatus = (data: SalesData[], status: string): SalesData[] => {
  return data.filter(sale => sale.status === status);
};

// Monthly revenue data for the RevenueBreakdownCard component
export const monthlyRevenueData = [
  { month: 'Jan', totalRevenue: 12450, masterLicenseShare: 8715, resellerShare: 3735 },
  { month: 'Feb', totalRevenue: 14230, masterLicenseShare: 9961, resellerShare: 4269 },
  { month: 'Mar', totalRevenue: 18760, masterLicenseShare: 13132, resellerShare: 5628 },
  { month: 'Apr', totalRevenue: 21340, masterLicenseShare: 14938, resellerShare: 6402 },
  { month: 'May', totalRevenue: 24890, masterLicenseShare: 17423, resellerShare: 7467 },
  { month: 'Jun', totalRevenue: 28450, masterLicenseShare: 19915, resellerShare: 8535 }
];
